import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import ReactMapGL, {Source, Layer} from 'react-map-gl';

import {MAPBOX_TOKEN} from "./../../helpers/consts";
import {baseStyle, countryLabelStyle, cityLabelStyle, placeLabelStyle} from "./../../helpers/baseMapLayer";

import {setMapViewportAction, setDefaultViewportAction} from "./../../actions/DataAction";
import {setTooltipDataAction} from "./../../actions/SettingsAction";

import {VIEWS} from "../../helpers/consts";

import MapControls from "./MapControls";

import GeoViewport from '@mapbox/geo-viewport';

import 'mapbox-gl/dist/mapbox-gl.css';
import "./Map.css";

class Map extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.boundsLimits = {minLat: 33, minLng: -10, maxLat: 75, maxLng: 33};
    this.state = {
      hoverFilter: ['in', 'id', '']
    }
    this.dataFormat = this.dataFormat.bind(this);
    this.getGeoGLConfig = this.getGeoGLConfig.bind(this);
    this.onMapHover = this.onMapHover.bind(this);
    this.onViewportChange = this.onViewportChange.bind(this);
    this.calculateMapSizes = this.calculateMapSizes.bind(this);
  }

  dataFormat(shapes) {
    return shapes;
  }

  componentDidMount() {
    setTimeout(() => {
      const {viewport, setDefaultViewportAction} = this.props;
      const sizes = this.calculateMapSizes();
      const results = GeoViewport.viewport(
        [
          this.boundsLimits.minLng,
          this.boundsLimits.minLat,
          this.boundsLimits.maxLng,
          this.boundsLimits.maxLat
        ],
        [
          sizes.w,
          sizes.h
        ]
      );
      const zoom = sizes.w < 800 ? 2.5 : results.zoom;
      setDefaultViewportAction(
        {
          ...viewport,
          longitude: results.center[0],
          latitude: results.center[1],
          zoom: zoom,
          minZoom: zoom
        });
    }, 1000);
  }

  componentWillUnmount() {

  }

  onViewportChange(newViewport) {
    const {setMapViewportAction} = this.props;

    if (newViewport.longitude < this.boundsLimits.minLng) {
      newViewport.longitude = this.boundsLimits.minLng;
    } else if (newViewport.longitude > this.boundsLimits.maxLng) {
      newViewport.longitude = this.boundsLimits.maxLng;
    }
    if (newViewport.latitude < this.boundsLimits.minLat) {
      newViewport.latitude = this.boundsLimits.minLat;
    } else if (newViewport.latitude > this.boundsLimits.maxLat) {
      newViewport.latitude = this.boundsLimits.maxLat;
    }

    setMapViewportAction(newViewport);
  }

  onMapHover(event) {
    const {features, srcEvent: {offsetX, offsetY}} = event;
    const {setTooltipData, width} = this.props;

    if(features){
      if (features.length === 0) {
        setTooltipData(null);
      } else {
        const feature = features.find(f=>f.source!=='mapbox');

        if (feature){
          //this.setState({hoverFilter: ['in', 'id', features[0].properties.id]});
          let direction, finalX, finalY;
          if(width>640){
            direction = offsetX + 25 + 320 < width ? 'R':'L';
            finalX = direction === 'R' ? offsetX + 10 : offsetX - 350;
            finalY = offsetY - 25;
          } else {
            direction = 'B';
            finalX = 0;
            finalY = offsetY + 10;
          }
          const hoveredFeature = {
            x: finalX,
            y: finalY,
            data: feature.properties,
            direction: direction
          };
          setTooltipData(hoveredFeature);
        } else {
          //this.setState({hoverFilter: ['in', 'id', '']});
          setTooltipData(null);
        }
      }
    }
  }

  getGeoGLConfig() {
    return baseStyle;
  }

  calculateMapSizes(){
    const {width, height} = this.props;
    return {
      w: width,
      h: height - 250
    }
  }

  render() {
    const {viewport, mapData, mapStyle, selectedCluster, selectedRegion, hashParts} = this.props;

    const selected = hashParts;

    const selectedItem = selectedCluster || selectedRegion;

    const isSelection = selectedItem.id !== 14 && selected.view === VIEWS.REGIONAL_CLUSTER;

    const selectedFilter = isSelection ? ['in', selectedItem.type==="Cluster"?'cluster_id':'id', selectedItem.id]:['in', 'id', ''];

    let mapSizes = this.calculateMapSizes();
    let mapLeftMargin = mapSizes.w < 1500 ? -30 : -(mapSizes.w - 1500)/2 - 15

    const regularMapStyle = {
      ...mapStyle,
      paint: {
        ...mapStyle.paint,
        "fill-opacity": isSelection?0.2:0.8,
        "fill-outline-color": "rgba(255,255,255,0.5)"
      }
    }

    const selectedMapStyle = {
      ...mapStyle,
      id: "selected",
      paint: {
        ...mapStyle.paint,
        "fill-opacity": 1,
        "fill-outline-color": "rgba(0,0,0,1)"
      }
    }

    return <div id="fow-map" style={{marginLeft: mapLeftMargin}}>
      <MapControls />
      <ReactMapGL
        ref={map => this.mapRef = map}
        {...viewport}
        scrollZoom={false}
        mapStyle={this.getGeoGLConfig()}
        height={mapSizes.h}
        width={mapSizes.w}
        mapboxApiAccessToken={MAPBOX_TOKEN}
        onViewportChange={this.onViewportChange}
        onHover={this.onMapHover}
      >
        {mapData && mapStyle && regularMapStyle && mapStyle.type === 'fill' && (
          <>
          <Source type="geojson" data={mapData}>
            <Layer {...regularMapStyle} />
            <Layer {...selectedMapStyle} filter={selectedFilter} />
          </Source>
          <Layer {...placeLabelStyle} />
          <Layer {...cityLabelStyle} />
          <Layer {...countryLabelStyle} />
          </>
        )}
      </ReactMapGL>
    </div>;
  }
}

const mapStateToProps = state => {
  return {
    hashParts: state.settings.hashParts,
    mapData: state.db.map.geojson,
    mapStyle: state.db.map.style,
    viewport: state.db.map.viewport,
    width: state.settings.window.width,
    height: state.settings.window.height,
    breakpoint: state.settings.window.breakpoint,
    selectedCluster: state.settings.map["Clusters"],
    selectedRegion: state.settings.map["Regions"]
  };
};
const mapDispatchToProps = dispatch => ({
  setTooltipData: data => dispatch(setTooltipDataAction(data)),
  setDefaultViewportAction: viewport => dispatch(setDefaultViewportAction(viewport)),
  setMapViewportAction: viewport => dispatch(setMapViewportAction(viewport))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Map));
